<template>
  <nav>
    <div class="container">
      <!-- <i class="material-icons hide-on-tablet-and-up mr-3">menu</i> -->
      <router-link :to="{ name: 'Landing' }">
        <div class="brand-logo">
          <div class="img">
            <img :src="require('@/assets/logo.png')" alt="">
          </div>
        </div>
      </router-link>
      <div class="links">
      </div>
      <div class="actions" ref="right">
        <slot name="actions">
          <template v-if="user.username">
            <span class="row vcenter pointer" @click="gotoProfile()">
              <p class="m-0 mr-2 hide-on-mobile">Hi, {{ user.firstName || user.username }}</p>
              <div class="avatar img">
                <img
                  v-if="user.image"
                  :src="require('@/assets/images/default_avatar_bg.jpg')"
                  :alt="`${user.firstName || user.username}'s image`"
                />
                <p v-else class="m-0">{{ user.username[0] }}</p>
              </div>
            </span>
          </template>
          <template v-else>
            <router-link :to="{ name: 'Login' }" class="ml-2">
              Login
            </router-link>
            <router-link :to="{ name: 'Signup' }" class="ml-2">
              Signup
            </router-link>
          </template>
        </slot>
      </div>
    </div>
  </nav>
</template>

<script>
/* eslint-disable no-undef */

import { mapGetters } from "vuex";

export default {
  name: "NavBar",
  computed: {
    ...mapGetters({
      user: "User/getDetails",
      loadingStatus: "User/getLoadingStatus",
    }),
  },
  methods: {
    gotoProfile() {
      this.$router.push({ name: "Profile" });
    },
  },
  created() {
    this.$store.dispatch("User/getDetails");
    this.$store.dispatch("Cart/cartItems");
  },
  mounted() {
    T.waves();
  },
};
</script>

<style lang="scss" scoped>
nav {
  background-color: white;
  position: sticky;
  top: 0;
  transition: $transition-fast-out;

  @supports ((backdrop-filter: blur(20px))) {
    backdrop-filter: blur(20px);
    background-color: #ffffff99;
  }

  .links {
    a {
      display: inline-block;
      margin: 0 .5rem;
    }
  }

  .container {
    width: 100%;
    justify-content: space-between;
  }

  .actions {
    display: flex;
    align-items: center;

    .avatar {
      display: grid;
      place-items: center;
      text-transform: uppercase;
      width: 35px;
      height: 35px;
      background-color: $blue;
      color: white;
      font-weight: bold;
      font-size: 1.15rem;
    }
  }
}
</style>

<style lang="scss">
.theme-dark nav {
  background-color: #2b2b2b79 !important;
  box-shadow: none !important;

  .avatar {
    color: $text-color !important;
  }
}
</style>
